import React from "react";
import "../../css/MarqueeText.css";

const MarqueeText = () => {
  return (
    <>
      <div className="text-content hidden md:flex flex-col tracking-wider text-[3.5vw] 2xl:leading-[4.8rem] mt-28 font-bold">
        <p className="flex flex-row items-center">
          compassionate care
          <span className=" md:h-6 md:w-6 xl:mx-4 mx-3 rounded-full bg-[#ffffff]"></span>
          world class imaging
        </p>
        <p>Right in your community</p>
      
      </div>
      <div className="text-content  md:hidden flex flex-col tracking-wider text-[6vw] sm:text-4xl font-bold">
        <p>compassionate care </p>
        <p>world class imaging</p>
        <p>Right in your community</p>
      </div>
    </>
  );
};
export default MarqueeText;
// import React from 'react';
// import '../../css/MarqueeText.css';

// const MarqueeText = () => {
//   const content = "compassionate care. world class imaging. Right in your community. ";

//   return (
//     <div className="marquee-wrapper">
//       <div className="marquee">
//         <div className="marquee-content">
//           {[...Array(10)].map((_, i) => (
//             <span key={i}>{content}</span>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };
// export default MarqueeText;
